import { Injectable } from "@angular/core";
import { HateoasResourceOperation } from "@lagoshny/ngx-hateoas-client";
import { SystemSearchMeta } from "@app/models/rest/system-search-meta";

@Injectable({
  providedIn: "root"
})
export class SystemSearchMetaRestService extends HateoasResourceOperation<SystemSearchMeta> {
  constructor() {
    super(SystemSearchMeta);
  }

  public findByEntityName(entityName: string) {
    // return new Observable();
    return super.searchResource("findByEntityName", {
      params: { entityName: entityName }
    });
  }
}
